export default __webpack_public_path__ + "static/media/table-chair.41a6a058.svg";